import CONFIG from '../config/config';
import getLanguage from '../helpers/language';

const sendEntryData = (data: {
  name?: string;
  company?: string;
  phone_number?: string;
  email?: string;
}, publicKey: string, conversationId: string) => {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Ocp-Apim-Subscription-Key', publicKey);

  const raw = JSON.stringify({
    'language': getLanguage(),
    'contact_provided': {
      'name': data.name,
      'company': data.company,
      'phone_number': data.phone_number,
      'email': data.email
    }
  });

  const requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: raw,
  };

  fetch(CONFIG.domain_url + 'conversation/update_conversation/' + conversationId, requestOptions)
    .then((response) => response.text())
    .catch((error) => console.error(error));
};

export default sendEntryData;